export default __webpack_public_path__ + "static/media/budget.d98c8ca1.png";